(function (root, factory) {
  if(typeof exports==='object' && typeof module!=='undefined') {
    var videojs = require('video.js');
    module.exports = factory(videojs.default || videojs);
  } else if(typeof define === 'function' && define.amd) {
    /*
    define(['videojs'], function(videojs){
      return (root.WistiaTech = factory(videojs));
    });
     */
  } else {
    root.StaticImageTech = factory(root.videojs);
  }
}(this, function(videojs) {
  'use strict';

  var Tech = videojs.getTech('Tech');

  var StaticImageTech = videojs.extend(Tech, {
    constructor: function(options, ready) {
      Tech.call(this, options, ready);
      this.setSrc(this.options_.source.src, true);
    },

    dispose: function() {
      this.el_.parentNode.classList.remove('vjs-static-image')

      this.el_.parentNode.removeChild(this.el_);
    },

    getParameterByName: function(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    createEl: function() {
      var wrapped = videojs.dom.createEl('img', {
        id: this.videoId,
        src: this.options_.source.src
      });

      // TODO: get the href query param, if it exists
      var href = this.getParameterByName('href', this.options_.source.src)
      if (href) {
        var a = videojs.dom.createEl('a', {
          href: href,
          target: '_blank'
        });
        a.appendChild(wrapped)
        wrapped = a
      }

      var divWrapper = videojs.dom.createEl('div', {
        id: 'static-image-wrapper'
      });
      divWrapper.appendChild(wrapped);

      var self = this
      setTimeout(function() {
        self.el_.parentNode.classList.add('vjs-static-image')
      },100)

      return divWrapper;
    },

    initPlayer: function() {
      var self = this;
    },

    ended: function() {
      // TODO: test expiration date on options?
    },

    onLoad: function() {
      // TODO: setup interval to test expiration?
    },

    ready: function() {

    },

    onReady: function() {
      this.isReady_ = true;
      this.triggerReady();
      this.trigger('loadedmetadata');
    },

    onPlay: function() {

    },

    onPause: function() {

    },

    onFinish: function() {

    },

    onSeek: function(data) {

    },

    onError: function(error){
      this.error = error;
      this.trigger('error');
    },

    error: function() {

    },

    playbackRate: function() {

    },

    setPlaybackRate: function(suggestedRate) {

      this.suggestedRate = suggestedRate;
      this.trigger('ratechange');
    },

    src: function(src) {
      if(src) {
        this.setSrc({ src: src });
      }
      return this.source;
    },

    setSrc: function(source) {
      if(!source || !source.src) {
        return;
      }

      this.source = source;
      this.videoOptions = StaticImageTech.parseUrl(source.src);
    },

    supportsFullScreen: function() {
      return false;
    },

    load: function() {},

    play: function() {

    },

    pause: function() {

    },

    paused: function() {
      return false;
    },

    currentTime: function() {
      return 0;
    },

    setCurrentTime: function(seconds) {

      this.player_.trigger('timeupdate');
    },

    duration: function() {
      return 0;
    },

    buffered: function() {
      return false;
    },

    volume: function() {
      return null;
    },

    setVolume: function(percentAsDecimal) {
      this.player_.trigger('volumechange');
    },

    currentSrc: function() {
      return this.el_.src;
    },

    muted: function() {
      return false;
    },

    setMuted: function(muted) {
      this.player_.trigger('volumechange');
    }
  });

  StaticImageTech.isSupported = function() {
    return true;
  };

  StaticImageTech.canPlayType = function(type) {
    return (type.indexOf('image/') === 0);
  };

  StaticImageTech.canPlaySource = function(e) {
    return StaticImageTech.canPlayType(e.type)
  };

  StaticImageTech.parseUrl = function(url) {
    return {}
  };

  if (typeof videojs.registerTech !== 'undefined') {
    videojs.registerTech('StaticImage', StaticImageTech);
  } else {
    videojs.registerComponent('StaticImage', StaticImageTech);
  }
}));
